import { createStyles, makeStyles } from '@material-ui/core';
import Colors from '../../layout/theme-next/colors';

const TRASH_ICON = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\'%3E%3Cpath d=\'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\'/%3E%3C/svg%3E")';

export default makeStyles((theme) =>
  createStyles({
    root: {
      '& .MuiOutlinedInput-root': {
        minHeight: 50,
        background: Colors.white,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[400],
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[500],
      },
    },
    inputRoot: {
      alignItems: 'center',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    tag: {
      margin: theme.spacing(0.25, 0.5, 0.25, 0),
      borderRadius: 4,
      background: Colors.hover,
      '& .MuiChip-label': {
        padding: theme.spacing(0.25, 1),
      },
    },
    endAdornment: {
      '& .MuiIconButton-root': {
        color: theme.palette.grey[600],
      },
    },
    popper: {
      zIndex: theme.zIndex.modal + 1,
    },
    paper: {
      marginTop: theme.spacing(0.5),
      border: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: theme.shadows[2],
    },
    listbox: {
      maxHeight: 280,
      padding: theme.spacing(0.5),
    },
    option: {
      ...theme.typography.body2,
      minHeight: 36,
      borderRadius: 4,
      '&[data-focus="true"]': {
        background: theme.palette.grey[200],
      },
      '&[aria-selected="true"]': {
        background: theme.palette.grey[300],
      },
    },
    deleteChip: {
      '& .MuiChip-root': {
        position: 'relative',
        overflow: 'hidden',
      },
      '& .MuiChip-root:not(.Mui-disabled):hover': {
        background: Colors.errorHighlight,
      },
      '& .MuiChip-root:not(.Mui-disabled):hover .MuiChip-label': {
        opacity: 0,
      },
      '& .MuiChip-root:not(.Mui-disabled) .MuiChip-deleteIcon': {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        opacity: 0,
        color: 'transparent',
        zIndex: 2,
      },
      '& .MuiChip-root:not(.Mui-disabled):hover::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 16,
        height: 16,
        backgroundColor: Colors.error,
        WebkitMaskImage: TRASH_ICON,
        maskImage: TRASH_ICON,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        pointerEvents: 'none',
        zIndex: 1,
      },
      '& .MuiChip-root.Mui-disabled': {
        opacity: 1,
        color: theme.palette.text.primary,
        background: Colors.hover,
      },
      '& .MuiChip-root.Mui-disabled .MuiChip-deleteIcon, & .MuiChip-root.Mui-disabled .MuiChip-deleteIconSmall': {
        display: 'none',
      },
    },
  }),
);
